import { Element } from '../../../../../../common/html/element'
import { getStyleHeightContainer } from '../../../helper'
import Chart from './Chart'

const Trend = ({
  data,
  isCheckbox,
  assetsCheckboxs,
  liabilitiesCheckboxs,
  equityCheckboxs,
  checked,
  setChecked,
  isDynamicReport,
  chart = [],
}) => {
  const isNoData = !data?.length

  if (isDynamicReport) {
    const countChart = chart.length
    const percentHeight = 100 - 3 * chart.length
    return (
      <div
        style={{
          height: getStyleHeightContainer(
            isDynamicReport,
            isNoData,
            (720 / 3) * countChart,
          ),
        }}
        className="flexColumn justifyContentBetween"
      >
        {chart.includes(1) && (
          <div
            className="w100"
            style={{
              height: `calc(${percentHeight}% / ${countChart})`,
            }}
          >
            <Chart
              data={data}
              isCheckbox={isCheckbox}
              checkboxs={assetsCheckboxs}
              checked={checked}
              setChecked={setChecked}
              title="financialAnalysis.ASSET_STRUCTURE"
              isDynamicReport={isDynamicReport}
            />
          </div>
        )}
        {chart.includes(2) && (
          <div
            className="w100"
            style={{ height: `calc(${percentHeight}% / ${countChart})` }}
          >
            <Chart
              data={data}
              isCheckbox={isCheckbox}
              checkboxs={liabilitiesCheckboxs}
              title="financialAnalysis.LIABILITIES_STRUCTURE"
              checked={checked}
              setChecked={setChecked}
              isDynamicReport={isDynamicReport}
            />
          </div>
        )}
        {chart.includes(3) && (
          <div
            className="w100"
            style={{ height: `calc(${percentHeight}% / ${countChart})` }}
          >
            <Chart
              data={data}
              isCheckbox={isCheckbox}
              checkboxs={equityCheckboxs}
              title="financialAnalysis.EQUITY_STRUCTURE"
              checked={checked}
              setChecked={setChecked}
              isEquityChart
              isDynamicReport={isDynamicReport}
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="dFlex h100">
      <div className="w45 h100">
        <Chart
          data={data}
          isCheckbox={isCheckbox}
          checkboxs={assetsCheckboxs}
          checked={checked}
          setChecked={setChecked}
          title="financialAnalysis.ASSET_STRUCTURE"
          isDynamicReport={isDynamicReport}
          isSmallXAxis
        />
      </div>
      <div className="w55 h100 dFlex">
        <Element
          style={{ borderLeft: '1px solid #D5D5D5' }}
          className="w50 h100"
        >
          <Chart
            data={data}
            isCheckbox={isCheckbox}
            checkboxs={liabilitiesCheckboxs}
            title="financialAnalysis.LIABILITIES_STRUCTURE"
            checked={checked}
            setChecked={setChecked}
            style={{ marginLeft: 8, marginRight: 8 }}
            isFooterUnder={true}
            isSmallXAxis
            isDynamicReport={isDynamicReport}
          />
        </Element>
        <Element
          style={{ borderLeft: '1px solid #D5D5D5' }}
          className="w50 h100"
        >
          <Chart
            data={data}
            isCheckbox={isCheckbox}
            checkboxs={equityCheckboxs}
            title="financialAnalysis.EQUITY_STRUCTURE"
            checked={checked}
            setChecked={setChecked}
            style={{ marginLeft: 8 }}
            isFooterUnder={true}
            isSmallXAxis
            isEquityChart
            isDynamicReport={isDynamicReport}
          />
        </Element>
      </div>
    </div>
  )
}

export default Trend
